<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="emit('close')"
  >
    <div class="flex justify-center">
      <div
        class="relative mx-4 mt-20 flex w-[300px] flex-col gap-4 rounded bg-white p-6 sm:w-[400px]"
      >
        <img
          class="absolute right-6 top-6 h-4 w-4 cursor-pointer"
          src="@/assets/close-icon.svg"
          alt="close icon"
          @click="$emit('close')"
        />

        <h3 class="text-left text-[24px] text-base text-dark-gray">
          Reject Rate Con
        </h3>

        <p class="text-left text-xs font-normal text-gray-500">
          Are you sure you want to reject?
        </p>
        <section class="ml-auto mt-2 flex gap-3">
          <button
            class="w-[100px] cursor-pointer rounded-md border border-gray-over-dark bg-white px-6 py-3 text-1md text-gray-over-dark hover:border-body-color hover:text-body-color focus:border-gray-over-dark focus:text-gray-over-dark"
            @click="emit('close')"
          >
            No
          </button>
          <ButtonMain
            :is-loading="loading"
            class="w-[100px] cursor-pointer rounded-md border border-yellow-500 bg-yellow-500 text-1md text-white hover:bg-light-orange focus:bg-dark-orange disabled:cursor-not-allowed disabled:border-light-gray disabled:bg-light-gray"
            @click="handleReject"
          >
            Yes
          </ButtonMain>
        </section>
      </div>
    </div>
  </modal>
</template>

<script setup>
import { defineProps } from 'vue';
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/ButtonMain.vue';

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'reject']);

const handleReject = () => {
  emit('reject');
};
</script>
